import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { isNavigationEnd } from '../operators';

/**
 * If there are any routes that we don't want to scroll the sidenav content to the top
 * after successful navigating to said route, put the route in this array.
 */
const urlsNotToScrollToTop: string[] = [];

/**
 * Scrolls the side-nav content of the application to the top when a component
 * is finished being routed to.
 */
@Injectable({
    providedIn: 'root'
})
export class ScrollTopService {
    constructor(private readonly _router: Router) {
        this._router.events
            .pipe(isNavigationEnd())
            .subscribe((navigationEnd: NavigationEnd) => {
                if (this.shouldNotScrollToTop(navigationEnd)) return;
                this.attemptToScrollToTop();
            });
    }

    private shouldNotScrollToTop(navigationEnd: NavigationEnd) {
        return urlsNotToScrollToTop.includes(navigationEnd.url);
    }

    private attemptToScrollToTop() {
        const sidenav = document.querySelector('mat-sidenav-content');
        if (sidenav) sidenav.scrollTop = 0;
    }
}
